module.exports = __webpack_public_path__ + "img/bottom-hero-section-bg.22f2eaae.png";